import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { OpsMoveCostItemToDifferentDepartmentComponent } from './ops-move-cost-item-to-different-department.component';

@NgModule({
  declarations: [
    OpsMoveCostItemToDifferentDepartmentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    OpsMoveCostItemToDifferentDepartmentComponent
  ]
})
export class OpsMoveCostItemToDifferentDepartmentModule { }
